import { CodeEditorSize } from '../CodeEditorExpandable/types';

export const DEFAULT_EDITOR_SIZE = CodeEditorSize.MD;
